module.exports = __webpack_public_path__ + "static/media/banner5 copy 3@2x.ceaa6f23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner5 copy 3@2x.png
// module id = 243
// module chunks = 0